import styled, {css} from 'styled-components'

import {BodySelector} from '@/src/config/settings'
import theme, {media} from '@/src/config/theme'

import {Label} from '@/src/shared/ui/label'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  & .ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date {
    height: unset;
  }

  & .ant-picker-calendar-mode-switch {
    display: none;
  }

  & .ant-picker-calendar-header {
    width: 100%;
    gap: 12px;

    & .ant-select-selector {
      border-color: ${theme.colors.gray};
    }
  }

  & .ant-picker-calendar-year-select,
  & .ant-picker-calendar-month-select {
    flex: 1;
  }

  & .ant-picker-calendar-month-select {
    order: 1;
  }

  & .ant-picker-calendar-year-select {
    order: 2;
  }

  ${BodySelector} & .ant-picker-cell {
    background: white;
    margin: unset;
    padding: unset;
    align-items: center;
    justify-content: center;

    & .ant-picker-cell-inner {
      margin: auto;
      background: unset;
      border-radius: 5px;
      border: unset;
      border-color: unset;

      &:hover {
        background: ${theme.colors.primary200};
      }
    }

    &.ant-picker-cell-selected {
      & .ant-picker-cell-inner {
        background: ${theme.colors.primary};

        * {
          color: ${theme.colors.dark};
        }
      }
    }
  }

  @media ${media.md} {
    flex-direction: row;
    gap: 62px;
  }
`

export const TimeSelect = styled.div`
  width: 100%;
  flex: 1;
`

export const TimeTitle = styled.div`
  font-weight: 450;
`

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  .ant-picker-calendar.ant-picker-calendar-full {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-content {
    display: none;
  }
`

export const TimeItems = styled.div`
  padding-top: 10px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, 44px);
`

export const TimeItem = styled.div<{$active: boolean}>`
  font-weight: 400;
  width: max-content;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;

  &:hover {
    background: ${theme.colors.primary200};
  }

  ${props =>
    props.$active &&
    css`
      background: ${theme.colors.primary};

      &:hover {
        background: ${theme.colors.primary};
      }
    `}
`

export const TimeSlotsEmptyLabel = styled(Label)``
